// Keep legacy numbers for existing products and orders; add the 2026-10-13 range.
const luckyNumbers = [
  '01001', '01002', '01003', '01004', '01005',
  '01011', '01012', '01013', '01014', '01015',
  '01006', '11006', '01200', '01201', '01202', '01203', '01204',
  '01205', '01206', '01207', '01208', '01209', '11206',
  '01210', '01211', '01212'
]

export function isLuckyProduct (number) {
  return luckyNumbers.includes(String(number))
}

export function isLuckyRingProduct (product) {
  const number = String(product.product_number)
  if (['01001', '01011', '01200'].includes(number)) return true
  // 01207 used to be a tie clip; distinguish legacy data by its stored name.
  return number === '01207' && (!product.name || product.name.includes('戒指'))
}

export function isLuckyWristProduct (product) {
  const number = String(product.product_number)
  if (['01005', '01015', '01204', '01211'].includes(number)) return true
  // 01209 now identifies the tie clip; retain support for named legacy wristwear.
  return number === '01209' && Boolean(product.name && product.name.includes('腕飾'))
}
